import provinces from "china-division/dist/provinces.json";
import cities from "china-division/dist/cities.json";
import areas from "china-division/dist/areas.json";
import streets from "china-division/dist/streets.json";
export const LEVEL_PROVINCE = 0
export const LEVEL_CITY = 1
export const LEVEL_AREA = 2
export const LEVEL_STREET = 3
function normalizeBaseData(items) {
  return items.reduce((obj, item) => {
    item.childs = []
    item.code = item.code.padEnd(6, '0')
    if (item.areaCode) {
      item.level = LEVEL_STREET
    } else if (item.cityCode) {
      item.level = LEVEL_AREA
    } else if (item.provinceCode) {
      item.level = LEVEL_CITY
    } else {
      item.level = LEVEL_PROVINCE
    }
    // item.level = item.provinceCode ? (
    //   item.cityCode ? LEVEL_AREA : LEVEL_CITY
    // ) : LEVEL_PROVINCE

    if (item.provinceCode) {
      item.provinceCode = item.provinceCode.padEnd(6, '0')
      if (item.level === LEVEL_CITY) {
        if (obj[item.provinceCode].childs.length == 0) {
          //填充父级ID
          obj[item.provinceCode].childs.push({ 'code': item.provinceCode, 'name': '全部' })
        }
        obj[item.provinceCode].childs.push(item)
      }
    }
    if (item.cityCode) {
      item.cityCode = item.cityCode.padEnd(6, '0')
      if (item.level === LEVEL_AREA) {
        if (obj[item.cityCode].childs.length == 0) {
          //填充父级ID
          obj[item.cityCode].childs.push({ 'code': item.cityCode, 'name': '全部' })
        }
        obj[item.cityCode].childs.push(item)
      }
    }
    if (item.areaCode) {
      item.areaCode = item.areaCode.padEnd(6, '0')

      if (item.level === LEVEL_STREET) {
        if (obj[item.areaCode].childs.length == 0) {
          //填充父级ID
          obj[item.areaCode].childs.push({ 'code': item.areaCode, 'name': '全部' })
        }
        obj[item.areaCode].childs.push(item)
      }
    }
    obj[item.code] = item
    return obj
  }, {})
}

const areaDataById = normalizeBaseData(provinces.concat(cities, areas, streets))

export default {
  provinces,
  cities,
  areas,
  byId: areaDataById
}

window.__areaDataById = areaDataById

/**
 * 去掉 自治区、特别行政区
 * @param {*} name
 */
function normalizeName(name) {
  if (/^内蒙古/.test(name)) {
    return '内蒙古'
  }
  if (/^西藏/.test(name)) {
    return '西藏'
  }
  if (/^新疆/.test(name)) {
    return '新疆'
  }
  if (/^香港/.test(name)) {
    return '香港'
  }
  if (/^澳门/.test(name)) {
    return '澳门'
  }
  if (/^广西/.test(name)) {
    return '广西'
  }
  if (/^宁夏/.test(name)) {
    return '宁夏'
  }
  return name
}

/**
 * 简化名字
 * @param {*} name
 */
export function simplifyName(name) {
  if (name.length > 2 && /市$/.test(name)) {
    return name.slice(0, name.length - 1)
  }

  if (/省$/.test(name)) {
    return name.slice(0, name.length - 1)
  }

  if (name === '市辖区') {
    return null
  }

  return name
}
/**
 * 获取上一级列表
 */
export function getParents(code, ignoreCurrent = false) {
  if (!areaDataById[code]) return []

  // return []

  let nextRegion = areaDataById[code]
  const parents = !ignoreCurrent ? [areaDataById[code]] : []

  while (nextRegion) {
    let parentId = nextRegion.areaCode || nextRegion.cityCode || nextRegion.provinceCode
    // NOTE: 中山市的 code === cityCode, 所以需要特殊处理
    // https://zhidao.baidu.com/question/1546063624231416427.html
    if (nextRegion.cityCode === nextRegion.code) {
      parentId = nextRegion.provinceCode
    }
    const parent = parentId && areaDataById[parentId]

    if (parent?.code) {
      parents.unshift(parent)
      nextRegion = parent
    } else {
      nextRegion = null
    }
  }

  return parents
}

/**
 * 获取完整名字
 * @param {*} areaCode
 */
export function getAddrText(areaCode) {
  if (Array.isArray(areaCode)) {
    const arr = areaCode
    return arr.map(code => areaDataById?.[code]?.name).filter(Boolean).join('-')
  }

  const parents = getParents(areaCode)
  return parents.map(item => simplifyName(normalizeName(item.name))).join('-')
}

/**
 * 将 一位地址 转换为 三位地址数组
 */
export function denormalizeCode(code) {
  const parents = getParents(code)

  return parents.map(item => item.code)
}

/**
 * 将 三位地址数组 转换为 一位地址数组
 */

export function normalizeCode(codeArr) {
  return codeArr.length ? codeArr[codeArr.length - 1] : null
}
